import { Button as MuiButton } from '@mui/material'
import { styled } from '@mui/system'

const Button = styled(MuiButton)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: 8,
  color: theme.palette.primary.secondary,
  '&:hover': {
    borderColor: theme.palette.primary.secondary,
  },
  fontSize: 14,
}))

export default function TextButton({ onClick, label = '', ...rest }) {
  return (
    <Button
      variant="text"
      sx={{ mr: 2 }}
      onClick={onClick}
      {...rest}
    >
      {label}
    </Button>
  )
}
